import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/app_pb';
import * as pbs from '@/grpc-gen/apps_service_pb';

import ApiApp from '@/model/AppStoreApp';

export default class App extends ApiApp {
  params?: string;

  static fromGrpcResponse(r: pbs.AppResponse): App {
    return App.fromGrpcModel(r.app);
  }

  static fromGrpcModel(o?: pbm.App): App {
    const a = new App();

    a.id = Number(o?.id ?? 0);
    a.name = o?.name ?? '';
    a.isInstalled = o?.isInstalled ?? false;
    a.params = o?.params || undefined;

    return a;
  }

  toGrpcModel(): pbm.App {
    return create(pbm.AppSchema, {
      id: BigInt(this.id),
      name: this.name ?? '',
      isInstalled: this.isInstalled ?? false,
      params: this.params ?? '',
    });
  }
}
